import { canFormCategoryGenerateReceipt } from "@simplyk/common";
import { useFormContext, useWatch } from "react-hook-form";

import { useRateContext } from "../../../../Context/RateContext";
import { useRateFieldName } from "../../../../hooks/useRateFieldName";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useShowTaxReceiptRow = (): boolean => {
  const { organization } = useCurrentUserContext();
  const { formCategory } = useRateContext();
  const { control } = useFormContext<StepTicketsFormData>();

  const isChecked = useWatch({ control, name: useRateFieldName("isGeneratingReceipt") });
  const eligibleAmount = useWatch({ control, name: useRateFieldName("receiptEligibleAmount") });

  if (!canFormCategoryGenerateReceipt(organization?.country, formCategory)) {
    return false;
  }

  return Boolean(organization?.canGenerateReceipt) || Boolean(isChecked && eligibleAmount);
};
